import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./StudentsResultsSection.css";
import studentResult1 from "assets/reviw1.jpg";
import studentResult2 from "assets/reviw2.jpg";
import studentResult3 from "assets/reviw3.jpg";
import studentResult4 from "assets/reviw4.jpg";

const studentResults = [
  studentResult1,
  studentResult2,
  studentResult3,
  studentResult4,
];

export default function StudentsResultsSection() {
  return (
    <section className="students-results-section">
      <h2 className="students-results-heading">Our Results</h2>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="students-results-swiper"
        breakpoints={{
          600: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
        }}
      >
        {studentResults.map((img, idx) => (
          <SwiperSlide key={idx}>
            <div className="students-result-card">
              <img src={img} alt={`Student Result ${idx + 1}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
} 